import { alpha, Autocomplete, Box, styled, Typography } from '@mui/material';

const Container = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  height: '100%',
  justifyContent: 'space-between',
}));

const HeaderRow = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: '1rem',
  width: '100%',
});

const InfoColumn = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
});

const Row = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1.5),
  alignItems: 'center',
}));

const DealNameContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.25rem',
});

const StyledLinkSpan = styled('span')(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: '0.95rem',
  color: theme.palette.primary.main,
  cursor: 'pointer',
}));

const LabelRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
});

const Field = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  minWidth: '45%',
});

const Label = styled(Typography)(() => ({
  fontWeight: '400',
  fontSize: '0.95rem',
}));

const Value = styled(Typography)({
  fontWeight: 'bold',
  fontSize: '0.95rem',
});

const StyledBadge = styled(Box)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.text.primary, 0.1),
  color: theme.palette.text.primary,
  fontSize: '0.85rem',
  borderRadius: theme.spacing(0.5),
  padding: theme.spacing(0.5, 1.5),
  cursor: 'pointer',
  width: 'fit-content',
  whiteSpace: 'nowrap',
}));

const StyledAutocomplete = styled(Autocomplete)({
  width: '10rem',
  fontSize: '0.75rem',
  '& .MuiAutocomplete-input': {
    height: '6px',
    fontSize: '0.75rem',
  },
});

export { Container, HeaderRow, DealNameContainer, InfoColumn, StyledLinkSpan, LabelRow, Label, Value, StyledBadge, Field, Row, StyledAutocomplete };
